import React, { CSSProperties } from "react"
import { colors, css } from "../Styles"

/* eslint-disable */
export enum TableStyles_Types {
  primaryTable = "primaryTable",
  noHeaderTable = "noHeaderTable",
  blueTable = "blueTable"
}
/* eslint-enable */

export const CreateTableStyle = (tableType?: TableStyles_Types | string) => {
  let tableStyle: CSSProperties = {};
  let headCellStyle: CSSProperties = {};
  let bodyCellStyle: CSSProperties = {};
  let bottomCellStyle: CSSProperties = {};
  let pinningBorderStyle: CSSProperties = {};

  switch (tableType) {
    case TableStyles_Types.noHeaderTable:
      tableStyle = {
        ...css.tableStyle,
        borderRadius: "10px"
      };
      headCellStyle = {
        display: "none"
      };
      bodyCellStyle = {
        ...css.bodyCellStyle
      };
      bottomCellStyle = {
        ...css.bottomCellStyle
      }
      pinningBorderStyle = {
        ...css.pinningBorderStyle
      }
    break;
    case TableStyles_Types.blueTable:
      tableStyle = {
        ...css.tableStyle,
        // maxHeight: "70vh",
        borderRadius: "0px 0px 10px 10px",
        scrollbarColor: colors.blueDarkSecondary+colors.blueDarkPrimary,
      };
      headCellStyle = {
        ...css.headCellStyle,
        height: "20px",
        backgroundColor: colors.blueDarkPrimary
      };
      bodyCellStyle = {
        ...css.bodyCellStyle,
      };
      bottomCellStyle = {
        ...css.bottomCellStyle,
        backgroundColor: colors.blueDarkPrimary,
      };
      pinningBorderStyle = { 
        border: "5px solid "+colors.blueDarkPrimary
      }
    break;
    case TableStyles_Types.primaryTable:
    default:
      tableStyle = {
        ...css.tableStyle
      };
      headCellStyle = {
        ...css.headCellStyle
      };
      bodyCellStyle = {
        ...css.bodyCellStyle
      };
      bottomCellStyle = {
        ...css.bottomCellStyle
      }
      pinningBorderStyle = {
        ...css.pinningBorderStyle
      }
  }
  return {
    tableStyle, headCellStyle, bodyCellStyle, bottomCellStyle, pinningBorderStyle
  };
};